export default __webpack_public_path__ + "static/media/YTL.aa74d450.png";